import { render, staticRenderFns } from "./expert-list.vue?vue&type=template&id=5550ce66&scoped=true&"
import script from "./expert-list.vue?vue&type=script&lang=js&"
export * from "./expert-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5550ce66",
  null
  
)

export default component.exports